var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1000 956.8",
    enableBackground: "new 0 0 1000 956.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "currentcolor",
    d: "M883.1,27l100,100L626,484.1l400,399.7l-100,100l-400-400l-400,400l-100-100 l400-400L68.9,127l100-100L526,383.8L883.1,27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseXs);
export default __webpack_public_path__ + "static/media/close-xs.6967e89333e04ea3101087b1c3e307d2.svg";
export { ForwardRef as ReactComponent };